import { render, staticRenderFns } from "./InformacoesServidor.vue?vue&type=template&id=676c9cfa"
import script from "./InformacoesServidor.vue?vue&type=script&lang=js"
export * from "./InformacoesServidor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports